import { getEsData } from "@/api/esdata";
import axiosClient from "@/libs/axiosClient";

export const getGroupThemeColorSet = async ({ type, groupName }) => {
    try {
        let result = await axiosClient.get(`/rest/group-owner-s3-data/themes/${type}`, { params: { groupName } });
        return result;
    } catch (err) {
        console.log(err);
        return {};
    }
};

export const updateCustomizeThemeColorSet = async ({ colorSet, groupName }) => {
    try {
        let result = await axiosClient.post(`/rest/group-owner-s3-data/themes?groupName=${groupName}`, {
            theme: { colorSet: colorSet }
        });
        return result;
    } catch (err) {
        console.log(err);
        return {};
    }
};

export const getGroupPrefs = async ({ type, groupName }) => {
    try {
        let result = await axiosClient.get(`/rest/group-owner-s3-data/prefs/${type}?groupName=${groupName}`);
        return result;
    } catch (err) {
        console.log(err);
        return {};
    }
};

export const clearGroupImage = async ({ type, groupName }) => {
    try {
        let result = await axiosClient.post(`uploads/${type}/img-clear?groupName=${groupName}`);
        return result;
    } catch (err) {
        console.log(err);
        return {};
    }
};

export const getGroupLoginPageLayout = async ({ type, groupName }) => {
    try {
        let result = await axiosClient.get(`/rest/group-owner-s3-data/layout/${type}?groupName=${groupName}`);
        return result;
    } catch (err) {
        console.log(err);
        return {};
    }
};

export const updateCustomizeLoginPageLayout = async ({ layout, groupName }) => {
    try {
        let result = await axiosClient.post(`/rest/group-owner-s3-data/layout?groupName=${groupName}`, {
            loginPageCss: layout
        });
        return result;
    } catch (err) {
        console.log(err);
        return {};
    }
};

export const updateGroupInfo = async ({ params, data, groupName }) => {
    try {
        let result = await axiosClient.post(`uploads/${params}?groupName=${groupName}`, data);
        return result.data;
    } catch (err) {
        console.log(err);
        return {};
    }
};

export const getGroupNames = async () => {
    try {
        let searchOptions = {
            esIndex: "rcm-edgegroup",
            from: 0,
            size: 999,
            sort: [{ "groupName.keyword": { order: "asc" } }],
            filters: [],
            _source: ["groupName"]
        };
        let result = await getEsData(searchOptions);
        let groupNames = result.data.mapData.map(e => e.groupName);
        return groupNames;
    } catch (err) {
        console.log(err);
        return [];
    }
};

export const getGroupResourceLimits = async ({ groupName }) => {
    try {
        let result = await axiosClient.get(`/group/resource-limits`, { params: { groupName } });
        let groupResourceLimits = result.data.data;
        return groupResourceLimits;
    } catch (err) {
        console.log(err);
        return {};
    }
};

export const _getNodeRegisterCommands = async ({ groupName, token, nodeType, registerMethod, serviceProvideType }) => {
    try {
        let apiEndpoint = nodeType == "edge" ? "/group/gen-edgeregister-command" : "/group/gen-slbregister-command";
        let result = await axiosClient.get(apiEndpoint, {
            params: { groupName, token, registerMethod, serviceProvideType }
        });
        let nodeRegisterCommands = result.data.message;
        return nodeRegisterCommands;
    } catch (err) {
        let errorObject = Object.assign({}, err);
        this.$store.commit("SET_FAIL_PAYMENT_GROUP", errorObject.response.data.groupInfo);
        this.$store.commit("SET_isPaymentOpened", true);
        return {};
    }
};

export const updateGroupCertData = async ({ data, groupName }) => {
    try {
        let result = await axiosClient.post(`group/rcm-aws-acme?groupName=${groupName}`, data);
        // console.log(result, "result")
        return result.data;
    } catch (err) {
        // console.log(err, "err")
        return err;
    }
};



// WEBPACK FOOTER //
// ./src/api/group.js